import { render, staticRenderFns } from "./PaymentOrderInvoiceSideForm.vue?vue&type=template&id=8ad65de6&scoped=true&"
import script from "./PaymentOrderInvoiceSideForm.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderInvoiceSideForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad65de6",
  null
  
)

export default component.exports